import { getContextValidationErrors } from "../validations/contextValidation";

import type {
  ExperimentFormData,
  FieldStatus,
  ValidationErrors,
} from "../types/experiment.types";

export type { FieldStatus, ValidationErrors };

export const useExperimentValidation = (experimentData: ExperimentFormData) => {
  const errors: ValidationErrors = getContextValidationErrors(experimentData);

  const getFieldStatus = (value: string): FieldStatus => {
    if (!value || !value.trim()) {
      return "empty";
    }
    if (value.trim().length < 20) {
      return "partial";
    }
    return "complete";
  };

  const validateField = (_field: string, _value: string): void => {
    return;
  };

  const required = [
    !!experimentData.name?.trim(),
    !!experimentData.goal?.trim(),
    !!experimentData.description?.trim(),
  ];
  const completeCount = required.filter(Boolean).length;
  const completionPercentage = Math.round((completeCount / required.length) * 100);

  return { errors, validateField, getFieldStatus, completionPercentage };
};
